import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Got an Idea for a Mobile App?</h2>
                        </div>
                        <p>Let's Shape Your Project Together! Share your vision, and together we'll craft a transformative mobile app development project to elevate elevate your business into a digital success story!</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;